export default __webpack_public_path__ + "static/media/47_earring.ef7df374.JPG";